<template>
  <div
    class="flex w-full flex-row justify-between gap-2.5 items-center px-4 py-2 bg-white text-[#55E0FD] border-t border-r border-b border-[#385660]">
    <div class="flex min-w-0 flex-1 flex-row gap-2 items-center">
      <div v-if="route.path !== '/'">
        <BackButtonComponent />
      </div>
      <h2 class="capitalize">{{ currentDate }}</h2>
    </div>
    <div class="flex shrink-0 flex-row gap-2 items-center justify-end">
      <!-- Botón de Email -->
      <template v-if="canSeeCalendar">
        <div class="relative">
          <ButtonComponent ref="noteButtonRef" :icon="CalendarNavbar" customClass="w-12" @click="toggleNoteDropdown" />
          <span v-if="unreadNotesCount > 0" class="absolute -top-1 -right-1 bg-red-500/70 text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center">{{ unreadNotesCount }}</span>
        </div>
      </template>
      <!-- Botón de alertas -->
      <div class="relative">
        <ButtonComponent ref="alertButtonRef" :icon="EmailIcon" customClass="w-12" @click="toggleAlertDropdown" />
        <span v-if="unreadCount > 0" class="absolute -top-1 -right-1 bg-red-500/70 text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center">{{ unreadCount }}</span>
      </div>

      <!-- Botón de configuración -->
      <ButtonComponent ref="configButtonRef" :icon="ConfigIcon" customClass="w-12" @click="toggleConfigDropdown" />

      <button @click="toggleMobileMenu" class="lg:hidden">
        <IconBurguer class="w-8 h-8" />
      </button>
    </div>
  </div>
      <!-- Dropdowns -->
      <div v-if="showNoteDropdown" ref="noteDropdownRef"
        class="absolute right-0 top-17 md:top-15 lg:right-[130px] md:right-[170px]  bg-[var(--c-primary)] rounded-2xl shadow-lg py-4 px-4 w-80 sm:w-96 z-50 tracking-wider">
        <ul class="text-xs flex flex-col justify-start gap-2.5 max-h-[400px] overflow-y-auto"
          @scroll="handleNoteScroll">
          <template v-if="AllNotes && AllNotes.length > 0">
            <li v-for="note in AllNotes" :key="note.id" :class="[
              'cursor-pointer flex flex-row items-center justify-start gap-2.5 px-2 py-2 border rounded-2xl',
              isRead(note.is_read)
                ? 'border-[#385660]/30 bg-[var(--vt-c-white-mute)] shadow-none'
                : 'border-[#385660] bg-[#fff] shadow-md'
            ]">
              <RouterLink class="flex flex-row items-center justify-start gap-1.5" :to="role === 'superadmin'
                ? `/request-detail-superadmin/${note.request_id}`
                : `/request-detail/${note.request_id}`" @click="handleNoteClick(note)">
                <p :class="['px-2', isRead(note.is_read) ? 'text-[#385660]/50' : 'text-[#55E0FD]']">{{ note.request.code }}
                </p>
                <div
                  :class="['w-2 h-[30px] py-2 px-1 rounded-full', isRead(note.is_read) ? 'bg-[#385660]/50' : 'bg-[#55E0FD]']">
                </div>
                <p :class="['truncate block max-w-[220px]', isRead(note.is_read) ? 'text-[#385660]/50' : 'text-[#385660]']"
                  :title="note.sender.name + ': ' + note.content">{{ note.sender.name }}: {{ note.content }}</p>
              </RouterLink>
            </li>
            <li v-if="loadingNotes" class="text-center text-white py-2">
              Cargando...
            </li>
          </template>
          <li v-else class="px-4 py-2 text-white">{{ $t('notifications.note.empty') }}</li>
        </ul>
      </div>

      <div v-if="showAlertDropdown" ref="alertDropdownRef"
        class="absolute right-0 top-17 md:top-15 lg:right-[80px] md:right-[120px] bg-[var(--c-primary)] rounded-2xl shadow-lg py-4 px-4 w-80 sm:w-96 z-50">
        <ul class="text-xs flex flex-col justify-start gap-2.5 max-h-[400px] overflow-y-auto"
          @scroll="handleNotificationScroll">
          <template v-if="AllNotifications.length > 0">
            <li v-for="notification in AllNotifications" :key="notification.id" :class="[
              'cursor-pointer flex flex-row items-center justify-start gap-1.5 py-2 px-2 border rounded-2xl',
              isRead(notification.is_read)
                ? 'border-[#385660]/30 bg-[var(--vt-c-white-mute)] shadow-none'
                : 'border-[#385660] bg-[#fff] shadow-md'
            ]">
              <RouterLink class="flex flex-row items-center justify-start gap-1.5" :to="role === 'superadmin'
                ? `/request-detail-superadmin/${notification.request_id}`
                : `/request-detail/${notification.request_id}`" @click="handleNotificationClick(notification)">
                <p :class="[isRead(notification.is_read) ? 'text-[#385660]/50' : 'text-[#55E0FD]']">{{ notification.code }}
                </p>
                <div :class="['w-2 h-[30px] rounded-full', isRead(notification.is_read) ? 'bg-[#385660]/50' : 'bg-[#55E0FD]']">
                </div>
                <p :class="['truncate block max-w-[240px]', isRead(notification.is_read) ? 'text-[#385660]/50' : 'text-[#385660]']"
                  :title="notification.sender.name + ': ' + notification.message">{{ notification.sender.name }}: {{
                    notification.message }}</p>
              </RouterLink>
            </li>
            <li v-if="loadingNotifications" class="text-center text-white py-2">
              Cargando...
            </li>
          </template>
          <li v-else class="px-4 py-2 text-white">{{ $t('notifications.empty') }}</li>
        </ul>
      </div>

      <div v-if="showConfigDropdown" ref="configDropdownRef"
        class="absolute right-[75px] top-17 md:top-15 md:right-[70px] lg:right-6 bg-[var(--c-primary)] rounded-2xl shadow-lg py-2 w-40 sm:w-48 z-50">
        <ul class="text-white text-sm flex w-full flex-col items-stretch justify-start text-left min-w-0">
          <!-- V1: cabecera con nombre + UserIcon (conservado, no borrar)
          <li v-if="userDisplayName" class="w-full min-w-0 border-b border-white/20 text-left">
            <div class="flex items-center gap-2 px-3 py-2 min-w-0">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center" aria-hidden="true">
                <UserIcon class="h-6 w-6 shrink-0" />
              </span>
              <p class="font-semibold leading-tight truncate min-w-0 flex-1 text-left" :title="userDisplayName">{{ userDisplayName }}</p>
            </div>
          </li>
          -->
          <template v-if="role == 'superadmin'">
            <li v-if="userDisplayName" class="w-full min-w-0 border-b border-white/20 text-left">
              <div class="flex items-center gap-2 px-3 py-2 min-w-0">
                <span class="flex h-6 w-6 shrink-0 items-center justify-center" aria-hidden="true">
                  <UserIcon class="h-6 w-6 shrink-0" />
                </span>
                <p class="button-title truncate min-w-0 flex-1 text-left leading-tight" :title="userDisplayName">{{ userDisplayName }}</p>
              </div>
            </li>
            <li class="w-full">
              <ButtonComponent :icon="LogoutIcon" :title="$t('settings.logout')"
                :customIcon="CONFIG_DROPDOWN_ICON_CLASS"
                class="!justify-start w-full flex flex-row items-center gap-2 rounded-none px-3 py-2 hover:bg-amber-50" @click="handleCLickLogout" />
            </li>
          </template>
          <template v-else>

            <li class="w-full">
              <ButtonComponent :icon="UserIcon" :title="userDisplayName || $t('settings.myData')"
                :customIcon="CONFIG_DROPDOWN_ICON_CLASS"
                customClassTitle="button-title truncate min-w-0 flex-1 text-left leading-tight"
                class="!justify-start w-full flex flex-row items-center gap-2 rounded-none px-3 py-2 hover:bg-amber-50" @click="handleClickRoute" />
            </li>
            <li class="w-full">
              <div class="relative group">
                <ButtonComponent :icon="LanguageIcon" :title="$t('settings.language')"
                  :customIcon="CONFIG_DROPDOWN_ICON_CLASS"
                  class="!justify-start w-full flex flex-row items-center gap-2 rounded-none px-3 py-2 hover:bg-amber-50" />
                <div
                  class="absolute right-full top-0 bg-[var(--c-primary)] rounded-lg shadow-lg py-2 w-48 z-50 hidden group-hover:block">
                  <div class="px-4 py-2 hover:bg-[#55E0FD] cursor-pointer" @click="changeLanguage('es')">
                    <span class="text-white">Español</span>
                  </div>
                  <div class="px-4 py-2 hover:bg-[#55E0FD] cursor-pointer" @click="changeLanguage('ca')">
                    <span class="text-white">Català</span>
                  </div>
                </div>
              </div>
            </li>
            <li class="w-full">
              <ButtonComponent :icon="LogoutIcon" :title="$t('settings.logout')"
                :customIcon="CONFIG_DROPDOWN_ICON_CLASS"
                class="!justify-start w-full flex flex-row items-center gap-2 rounded-none px-3 py-2 hover:bg-amber-50" @click="handleCLickLogout" />
            </li>
          </template>
        </ul>
      </div>


</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import CalendarNavbar from '@/assets/svg/CalendarNavbar.vue';
import ButtonComponent from '../button/button-component.vue';
import ConfigIcon from '@/assets/svg/ConfigIcon.vue';
import UserIcon from '@/assets/svg/UserIcon.vue';
import LogoutIcon from '@/assets/svg/LogoutIcon.vue';
import LanguageIcon from '@/assets/svg/LanguageIcon.vue';
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';
import EmailIcon from '@/assets/svg/EmailIcon.vue';
import { useI18n } from 'vue-i18n';
import BackButtonComponent from '@/components/button/BackButtonComponent.vue';
import IconBurguer from '@/components/icons/IconBurguer.vue';
import { hasAnyRole } from '@/services/userRoles';
import { toast } from 'vue3-toastify';

const currentDate = ref('');

const role = localStorage.getItem('role');
// Calendario de seguimientos: todo el Back Office y los superadministradores
// (ADSREC-0011). Comerciales y clientes no lo usan.
const canSeeCalendar = hasAnyRole(['admin', 'superadmin']);

onMounted(() => {
  void refreshUserDisplayName();
  const token = localStorage.getItem('token');
  // La campanita se ve siempre: la ficha del cliente solo decide qué correos
  // recibe, no los avisos dentro de la plataforma (ADS-0185).
  if (token) {
    fetchUnreadCount();
    // Consulta ligera cada pocos segundos para que una notificación nueva salte
    // enseguida (ADS-0175). Con la pestaña oculta no se consulta: al volver a
    // ella se refresca en el acto.
    notificationsInterval.value = setInterval(() => {
      if (!document.hidden) fetchUnreadCount();
    }, NOTIFICATIONS_POLL_MS);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    if (canSeeCalendar) {
      getAllNotes();
      fetchUnreadNotesCount();
      notesInterval.value = setInterval(() => {
        fetchUnreadNotesCount();
        if (showNoteDropdown.value) getAllNotes(1);
      }, 60000);
    }
  }

  const now = new Date();
  currentDate.value = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(now);

});

const router = useRouter();
const route = useRoute();

// Estados de los dropdowns
const showConfigDropdown = ref(false);
const userDisplayName = ref('');
const CONFIG_DROPDOWN_ICON_CLASS = 'h-6 w-6 shrink-0';
const showAlertDropdown = ref(false);
const showNoteDropdown = ref(false);

// Referencias a elementos del DOM
const alertDropdownRef = ref(null);
const configDropdownRef = ref(null);
const noteDropdownRef = ref(null);

const alertButtonRef = ref(null);
const configButtonRef = ref(null);
const noteButtonRef = ref(null);

const AllNotifications = ref([]);
const AllNotes = ref(null);
const isMobileMenuOpen = ref(false)
const currentPageNotifications = ref(1);
const currentPageNotes = ref(1);
const loadingNotifications = ref(false);
const loadingNotes = ref(false);
const hasMoreNotifications = ref(true);
const hasMoreNotes = ref(true);
const unreadCount = ref(0);
const unreadNotesCount = ref(0);
const notificationsInterval = ref(null);
const notesInterval = ref(null);
const NOTIFICATIONS_POLL_MS = 10000;
// Última bandeja vista (última notificación y no leídas): el listado solo se
// vuelve a pedir cuando cambia.
let lastInboxState;

const { locale, t } = useI18n();

const emit = defineEmits(['toggle-mobile-menu']);

const isRead = (value) => value === true || value === 1 || value === '1';

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  emit('toggle-mobile-menu', isMobileMenuOpen.value);
}

const changeLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('lang', lang);
};

const toggleNoteDropdown = () => {
  showNoteDropdown.value = !showNoteDropdown.value;
  showAlertDropdown.value = false;
  showConfigDropdown.value = false;
};

const refreshUserDisplayName = async () => {
  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');
  if (!id || !token) {
    userDisplayName.value = '';
    return;
  }
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/get/${id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.data?.value ?? response.data;
    if (!data || typeof data !== 'object') {
      userDisplayName.value = '';
      return;
    }
    const fromNameSurname = [data.name, data.surname]
      .map((s) => (s == null ? '' : String(s).trim()))
      .filter(Boolean)
      .join(' ')
      .trim();
    const username = data.username != null ? String(data.username).trim() : '';
    const email = data.email != null ? String(data.email).trim() : '';
    userDisplayName.value = fromNameSurname || username || email || '';
  } catch {
    userDisplayName.value = '';
  }
};

const toggleConfigDropdown = async () => {
  const willOpen = !showConfigDropdown.value;
  showConfigDropdown.value = willOpen;
  showAlertDropdown.value = false;
  showNoteDropdown.value = false;
  if (willOpen) {
    await refreshUserDisplayName();
  }
};

const toggleAlertDropdown = () => {
  showAlertDropdown.value = !showAlertDropdown.value;
  showConfigDropdown.value = false;
  showNoteDropdown.value = false;
  // Al abrirlo se muestra siempre la bandeja al día, sin esperar a la consulta.
  if (showAlertDropdown.value) fetchUnreadCount({ reloadList: true });
};

const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') fetchUnreadCount();
};

// Detectar clics fuera
const handleClickOutside = (event) => {
  const isAlertButton = alertButtonRef.value?.$el?.contains(event.target);
  const isConfigButton = configButtonRef.value?.$el?.contains(event.target);
  const isInsideAlert = alertDropdownRef.value?.contains(event.target);
  const isInsideConfig = configDropdownRef.value?.contains(event.target);
  const isInsideNote = noteDropdownRef.value?.contains(event.target);
  const isNoteButton = noteButtonRef.value?.$el?.contains(event.target);

  if (!isAlertButton && !isConfigButton && !isNoteButton && !isInsideAlert && !isInsideConfig && !isInsideNote) {
    showAlertDropdown.value = false;
    showConfigDropdown.value = false;
    showNoteDropdown.value = false;
  }

};

// Eventos globales
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  if (notificationsInterval.value) clearInterval(notificationsInterval.value);
  if (notesInterval.value) clearInterval(notesInterval.value);
});

const getAllNotifications = async (page = 1, perPage = 10) => {
  try {
    if (loadingNotifications.value) return false;
    loadingNotifications.value = true;

    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/notification/list`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        per_page: perPage,
        page: page
      }
    });

    if (response.data?.value.data) {
      if (page === 1) {
        AllNotifications.value = response.data.value.data;
      } else {
        AllNotifications.value = [...AllNotifications.value, ...response.data.value.data];
      }
      // El contador de no leídas sale del resumen de la bandeja, no de las
      // páginas descargadas.
      hasMoreNotifications.value = response.data.value.data.length === 10;
      currentPageNotifications.value = page;
    } else {
      AllNotifications.value = [];
      hasMoreNotifications.value = false;
    }
    return true;
  } catch (error) {
    console.error(error);
    AllNotifications.value = [];
    hasMoreNotifications.value = false;
    return false;
  } finally {
    loadingNotifications.value = false;
  }
};

// Resumen de la bandeja (ADS-0175): no leídas y última notificación, sin
// descargar el listado. El
// listado se recarga solo si la bandeja cambió o si se pide expresamente.
const fetchUnreadCount = async ({ reloadList = false } = {}) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/notification/unread-summary`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
    const summary = response.data?.value;
    unreadCount.value = Number(summary.unread) || 0;
    const inboxState = `${summary.latest_id ?? ''}:${summary.unread}`;
    if ((reloadList || inboxState !== lastInboxState) && await getAllNotifications(1)) {
      lastInboxState = inboxState;
    }
  } catch (error) {
    // Un fallo puntual no borra el contador: se reintenta en la siguiente consulta.
    console.error('Error fetching unread count:', error);
  }
};

const fetchUnreadNotesCount = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) { unreadNotesCount.value = 0; return; }
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/notes/list`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        per_page: 1000,
        page: 1
      }
    });
    if (response.data?.value?.data) {
      unreadNotesCount.value = response.data.value.data.filter(n => !isRead(n.is_read)).length;
    } else {
      unreadNotesCount.value = 0;
    }
  } catch (error) {
    console.error('Error fetching unread notes count:', error);
    unreadNotesCount.value = 0;
  }
};

const getAllNotes = async (page = 1) => {
  try {
    if (loadingNotes.value) return;
    loadingNotes.value = true;

    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/notes/list`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        per_page: 10,
        page: page
      }
    });

    if (response.data?.value.data) {
      if (page === 1) {
        AllNotes.value = response.data.value.data;
      } else {
        AllNotes.value = [...AllNotes.value, ...response.data.value.data];
      }
      // actualizar contador de notas no leídas
      try {
        unreadNotesCount.value = AllNotes.value.filter(n => !isRead(n.is_read)).length;
      } catch {
        unreadNotesCount.value = 0;
      }
      hasMoreNotes.value = response.data.value.data.length === 10;
      currentPageNotes.value = page;
    } else {
      AllNotes.value = [];
      hasMoreNotes.value = false;
    }
  } catch (error) {
    console.error(error);
    AllNotes.value = [];
    hasMoreNotes.value = false;
  } finally {
    loadingNotes.value = false;
  }
};

const handleNotificationScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target;
  if (scrollHeight - scrollTop <= clientHeight * 1.5 && !loadingNotifications.value && hasMoreNotifications.value) {
    getAllNotifications(currentPageNotifications.value + 1);
  }
};

const handleNoteScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target;
  if (scrollHeight - scrollTop <= clientHeight * 1.5 && !loadingNotes.value && hasMoreNotes.value) {
    getAllNotes(currentPageNotes.value + 1);
  }
};

const handleClickRoute = () => {

  router.push({ name: 'settings' });

  showConfigDropdown.value = false;
  showAlertDropdown.value = false;
  showNoteDropdown.value = false;
};

const handleCLickLogout = () => {

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('id');
  localStorage.removeItem('role');
  localStorage.removeItem('name');
  localStorage.clear();

  router.push({ name: 'login' });
  showConfigDropdown.value = false;
  showAlertDropdown.value = false;
  showNoteDropdown.value = false;
  if (notificationsInterval.value) clearInterval(notificationsInterval.value);
  if (notesInterval.value) clearInterval(notesInterval.value);

};

const updateNotificationRead = async (id) => {
  try {
    await axios.put(`${import.meta.env.VITE_API_URL}/notification/update/${id}`,
      { is_read: true },
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    // Refresca el contador y el listado de una vez (ADS-0175).
    await fetchUnreadCount({ reloadList: true });
  } catch (error) {
    console.error('Error updating notification:', error);
  }
};

const updateNoteRead = async (id) => {
  try {
    await axios.put(`${import.meta.env.VITE_API_URL}/request/notes/update/${id}`,
      { is_read: true },
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    // refrescar contador de notas
    fetchUnreadNotesCount();
  } catch (error) {
    console.error('Error updating note:', error);
    // Sin aviso, el seguimiento quedaba pendiente sin que nadie supiera por qué.
    toast.error(t('notifications.note.markReadError'), { position: 'top-right', autoClose: 5000 });
  }
};

const handleNotificationClick = async (notification) => {
  await updateNotificationRead(notification.id);
};

const handleNoteClick = async (note) => {
  await updateNoteRead(note.id);
  await getAllNotes();
};
</script>


<style scoped>
.bg-gradient {
  background-image: linear-gradient(to right, #385660, #49707e, #3a5762);
}

.iconCustom {
  color: #fff
}

.iconCustom:hover {
  color: #fff;
}
</style>
